import * as React from "react";
function SvgIcClose(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.647 5l-6.48 6.481L5.715 5.03 5 5.747l6.452 6.45-6.422 6.42.717.717 6.42-6.422 6.45 6.452.717-.716-6.451-6.451 6.48-6.48L18.648 5z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcClose;
